export default class DisputeTaskListItem {
  constructor(params = {}) {
    this.bookingId = params.bookingId
    this.locationId = params.locationId
    this.locationTitle = params.locationTitle
    this.candidateId = params.candidateId
    this.taskId = params.taskId
    this.taskType = params.taskType
    this.assignedTo = params.assignedTo
    this.candidateName = params.candidateName
    this.startTimeLocal = params.startTimeLocal
    this.endTimeLocal = params.endTimeLocal
    this.breakMinutes = params.breakMinutes
    this.candidateSubmittedDate = params.candidateSubmittedDate
    this.isRestBreakCompliant =
      params.isRestBreakCompliant !== undefined
        ? params.isRestBreakCompliant
        : null
  }

  /**
   * Check if candidate has submitted a timesheet
   * @returns {boolean}
   */
  get candidateHasSubmitted() {
    return Boolean(this.candidateSubmittedDate)
  }

  /**
   * Check if client has submitted a timesheet
   * @returns {boolean}
   */
  get clientHasSubmitted() {
    return Boolean(this.clientSubmittedDate)
  }

  /**
   * Check if rest break compliance value is available
   * @returns {boolean}
   */
  get hasRestBreakCompliantValue() {
    return (
      this.isRestBreakCompliant !== null &&
      typeof this.isRestBreakCompliant !== 'undefined'
    )
  }

  /**
   * Get booking date time display (combination of startTimeLocal and endTimeLocal)
   * Used for the bookingDateTime column
   * @returns {Object}
   */
  get bookingDateTime() {
    return {
      startTimeLocal: this.startTimeLocal,
      endTimeLocal: this.endTimeLocal,
    }
  }
}
